import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SimpleMDE from 'react-simplemde-editor'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import ModalComponent from '../ModalComponent'
import CommentLabelDropdown from './CommentLabelDropdown'

import labels from '../../../utils/commentlabels'
import {
  deleteComment,
  editComment,
  postComment,
  isEditingComment,
  isNotEditingComment
} from '../../../actions/comments'
import { simpleMDEOptions } from '../../../utils/index'
import { getCommentResourceType } from '../../../utils/quest'
import { getUserDisplayName } from '../../../utils/name'
import UserName from '../UserName'

export default class DraftComment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: props.comment ? props.comment.body : '',
      isDirty: false,
      savedData: props.comment && props.comment.id ? true : false,
      id: props.comment ? props.comment.id : null
    }

    this.onDeleteClickBound = this.onDeleteClick.bind(this)
    this.hideModalBound = this.hideModal.bind(this)
    this.onActualDeleteClickBound = this.onActualDeleteClick.bind(this)
    this.handleCommentChangeBound = this.handleCommentChange.bind(this)
    this.onLabelChangeBound = this.onLabelChange.bind(this)
    this.saveDraftCommentBound = this.saveDraftComment.bind(this)
    this.onPublishCommentClickBound = this.onPublishCommentClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.comment.body !== this.props.comment.body ||
      nextProps.comment.id !== this.props.comment.id ||
      nextProps.section !== this.props.section
    ) {
      this.setState(() => {
        return {
          comment: nextProps.comment ? nextProps.comment.body : '',
          id: nextProps.comment ? nextProps.comment.id : null,
          isDirty: false,
          savedData: nextProps.comment && nextProps.comment.id ? true : false
        }
      })
    }
  }

  // To address wonky autoscroll happening when navigating to a quest with a draft comment in basic info
  componentDidMount() {
    if (!this.props.isNewDraft) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { comment, user } = this.props

    if (!comment) {
      return null
    } else {
      const options = Object.assign({}, simpleMDEOptions)
      options.autofocus = this.props.isNewDraft
      options.placeholder = 'Type your comment here.'

      return (
        <li className="draft-comment">
          <div className="comment-header">
            <div className="comment-icon draft" />
            <div className="comment-header-text h4">
              {`Draft Comment${
                this.state.savedData && !this.state.isDirty ? ' (Saved)' : ''
              }`}
            </div>
          </div>
          <div className="shadow">
            <div className="comment-body-header">
              <div className="comment-user-photo">
                <div className="user-photo-wrapper">
                  <img src={user.photo.url} />
                </div>
              </div>
              <div className="comment-user-info">
                <UserName
                  activeCertifications={user.active_certifications}
                  userId={`draft-comment-${user.id}`}
                  rebuild
                >
                  <div className="comment-user-name">
                    {getUserDisplayName(user)}
                  </div>
                </UserName>
                <div className="commented-on" style={{ marginLeft: '7px' }}>
                  comment on
                </div>
                <div className="labels">
                  <CommentLabelDropdown
                    labels={labels[this.props.section]}
                    selectedValue={comment.label}
                    onChange={this.onLabelChangeBound}
                    type="Draft"
                  />
                </div>
              </div>
            </div>

            <div className="edit-comment-area">
              <SimpleMDE
                key={this.state.id}
                value={this.state.comment}
                options={options}
                onChange={this.handleCommentChangeBound}
              />
              <div className="actions">
                <div
                  className={
                    this.state.comment.trim().length === 0
                      ? 'button save disabled btn-primary-small'
                      : 'button btn-primary-small save'
                  }
                  onClick={this.onPublishCommentClickBound}
                >
                  Post Comment
                </div>
                <React.Fragment>
                  <div
                    onClick={this.saveDraftCommentBound}
                    className={
                      !this.state.isDirty ||
                      this.state.comment.trim().length === 0
                        ? 'btn-secondary-small button disabled save-draft'
                        : 'button btn-secondary-small save-draft'
                    }
                  >
                    Save Draft
                  </div>
                  {this.state.savedData && (
                    <div className="save-state-container caption1">
                      {this.state.isDirty ? (
                        'Unsaved changes'
                      ) : (
                        <span>
                          {'Last saved '}
                          <OEComponents.ElapsedTimeFormatter
                            time={comment.updated_at}
                          />
                        </span>
                      )}
                    </div>
                  )}
                  <div
                    className="trash delete-draft-comment"
                    onClick={this.onDeleteClickBound}
                  />
                </React.Fragment>
              </div>
              <div className="caption1 notification">
                Posting your comment will notify the active quest authors and
                anyone else that has posted a comment on this section. Saving
                your comment allows you to finish your comment later. Only you
                can see your saved comments.
              </div>
            </div>
          </div>
          <ModalComponent
            ref="deleteCommentModal"
            klass="modal delete-comment-modal"
            modalId="commentDeleteModal"
            headingKlass="modal-heading h3"
            logoKlass="logo delete-comment"
            headingText="Delete comment?"
            bodyText=""
            primaryButtonText="Yes, Delete"
            secondaryButtonText="Cancel"
            primaryButtonAction={this.onActualDeleteClickBound}
            secondaryButtonAction={this.hideModalBound}
          />
        </li>
      )
    }
  }

  handleCommentChange(val) {
    this.setState(() => {
      return {
        comment: val,
        isDirty: true
      }
    })

    this.props.dispatch(isEditingComment())
  }

  onLabelChange() {
    this.setState({ isDirty: true })
    this.props.dispatch(isEditingComment())
  }

  onDeleteClick() {
    const { comment } = this.props
    if (!comment.id && this.state.comment.trim().length === 0) {
      this.props.cancelDraftClick()
      this.props.dispatch(isNotEditingComment())
    } else {
      this.refs.deleteCommentModal.refs.modal.show()
    }
  }

  onActualDeleteClick() {
    const { comment, dispatch } = this.props
    if (comment.id) {
      dispatch(
        deleteComment(
          comment.resource_id,
          getCommentResourceType(comment),
          comment.id,
          'draft'
        )
      )
    } else {
      this.props.dispatch(isNotEditingComment())
    }
    this.hideModal()
  }

  hideModal() {
    this.refs.deleteCommentModal.refs.modal.hide()
  }

  async saveDraftComment() {
    const { comment, dispatch } = this.props
    var labels = document.getElementById('commentLabelDraft')
    var selectedLabel = labels.options[labels.selectedIndex].value
    if (this.props.comment.id) {
      await dispatch(
        editComment(
          comment.resource_id,
          getCommentResourceType(comment),
          comment.id,
          this.state.comment,
          selectedLabel,
          'draft'
        )
      )
    } else {
      await dispatch(
        postComment(
          this.props.resourceId,
          this.props.section,
          selectedLabel,
          this.state.comment
        )
      )
    }

    this.setState(() => {
      return {
        savedData: true,
        isDirty: false
      }
    })
  }

  async onPublishCommentClick() {
    const { comment, dispatch } = this.props
    var labels = document.getElementById('commentLabelDraft')
    var selectedLabel = labels.options[labels.selectedIndex].value
    if (this.props.comment.id) {
      await dispatch(
        editComment(
          comment.resource_id,
          getCommentResourceType(comment),
          comment.id,
          this.state.comment,
          selectedLabel,
          'draft',
          true
        )
      )

      this.setState(() => {
        return {
          isDirty: false,
          savedData: true
        }
      })
    } else {
      dispatch(
        postComment(
          this.props.resourceId,
          this.props.section,
          selectedLabel,
          this.state.comment,
          true
        )
      )
    }
  }
}

DraftComment.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
  comment: PropTypes.object.isRequired,
  section: PropTypes.string,
  resourceId: PropTypes.number,
  cancelDraftClick: PropTypes.func.isRequired,
  isNewDraft: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/mini/comments/DraftComment.js